export default "__VITE_ASSET__becd569a__"